<div class="modal-container">
  <div class="modal-header">
    <h2 class="modal-title">
      <mat-icon>lock_reset</mat-icon>
      <span>{{ 'login.alteracaoSenha' | translate }}</span>
    </h2>
    <button class="close-button" (click)="dialogRef.close()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="info-block">
      <div class="user-line">
        {{ ('telaUsuario.usuario' | translate) + ': ' }} <b>{{ login }}</b>
      </div>
      <div class="instruction">{{ 'login.alteracaoSenhaInstrucao' | translate }}</div>
    </div>

    <form class="password-form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'telaUsuario.senha' | translate }}</mat-label>
        <input
          type="password"
          ngModel
          #SenhaNovat
          name="senha"
          matInput
          (keypress)="impedirEspaco($event)"
          (keyup)="validaRegraSenha(filtro)"
          placeholder="{{ 'telaUsuario.senha' | translate }}"
          [(ngModel)]="objAlteracao.senha"
        />
        <button mat-icon-button matSuffix type="button" (click)="mostrarSenha(SenhaNovat)">
          <mat-icon *ngIf="SenhaNovat.type == 'password'">visibility_off</mat-icon>
          <mat-icon *ngIf="SenhaNovat.type == 'text'">visibility</mat-icon>
        </button>
      </mat-form-field>

      <div class="password-rules">
        <p class="strength-label" *ngIf="filtro.strengthLabelKey" [ngClass]="'strength-' + filtro.strengthClass">
          {{ filtro.strengthLabelKey | translate }}
        </p>
        <div class="progress">
          <div
            id="password-strength"
            class="progress-bar"
            role="progressbar"
            [style.width.%]="filtro.strengthPercent"
            [ngClass]="{
              'progress-bar-empty': filtro.strengthClass === 'empty',
              'progress-bar-danger': filtro.strengthClass === 'weak',
              'progress-bar-warning': filtro.strengthClass === 'medium',
              'progress-bar-success': filtro.strengthClass === 'strong'
            }"
          ></div>
        </div>
        <ul class="list-unstyled">
          <li>
            <i class="fa" [ngClass]="{ 'fa-circle': !filtro.lowUpperCase, 'fa-check': filtro.lowUpperCase }" aria-hidden="true"></i>
            &nbsp;{{ 'telaUsuario.RegraSenha1' | translate }}
          </li>
          <li>
            <i class="fa" [ngClass]="{ 'fa-circle': !filtro.number, 'fa-check': filtro.number }" aria-hidden="true"></i>
            &nbsp;{{ 'telaUsuario.RegraSenha2' | translate }}
          </li>
          <li>
            <i class="fa" [ngClass]="{ 'fa-circle': !filtro.specialChar, 'fa-check': filtro.specialChar }" aria-hidden="true"></i>
            &nbsp;{{ 'telaUsuario.RegraSenha3' | translate }}
          </li>
          <li>
            <i class="fa" [ngClass]="{ 'fa-circle': !filtro.eightChar, 'fa-check': filtro.eightChar }" aria-hidden="true"></i>
            &nbsp;{{ 'telaUsuario.RegraSenha4' | translate }}
          </li>
          <li>
            <i class="fa" [ngClass]="{ 'fa-circle': filtro.senhaFraca, 'fa-check': !filtro.senhaFraca }" aria-hidden="true"></i>
            &nbsp;{{ 'telaUsuario.RegraSenha5' | translate }}
          </li>
        </ul>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'telaUsuario.repetirSenha' | translate }}</mat-label>
        <input
          type="password"
          name="confSenha"
          matInput
          ngModel
          #ConfirmeSenha
          (keypress)="impedirEspaco($event)"
          (keyup)="validaRegraSenha(filtro)"
          placeholder="{{ 'telaUsuario.repetirSenha' | translate }}"
          [(ngModel)]="filtro.confirmacaoSenha"
        />
        <button mat-icon-button matSuffix type="button" (click)="mostrarSenha(ConfirmeSenha)">
          <mat-icon *ngIf="ConfirmeSenha.type == 'password'">visibility_off</mat-icon>
          <mat-icon *ngIf="ConfirmeSenha.type == 'text'">visibility</mat-icon>
        </button>
        <mat-hint *ngIf="filtro.senhaDiferente && filtro.confirmacaoSenha.length > 0" class="erro">
          {{ 'telaUsuario.repetirSenhaErro' | translate }}
        </mat-hint>
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" mat-raised-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
      {{ 'telaUsuario.fechar' | translate }}
    </button>
    <button
      type="submit"
      (click)="alterarSenha()"
      [disabled]="!senhaValida"
      mat-raised-button
      color="primary"
    >
      <mat-icon>save</mat-icon>
      {{ 'login.alterar' | translate }}
    </button>
  </div>
</div>